/* Six & Grace theme JS — tabs + bare swipeable slideshow. No dependencies. */
(function () {
  'use strict';

  /* ---------- tabs ---------- */
  document.querySelectorAll('[data-sg-tabs]').forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = {};
    buttons.forEach(function (btn) {
      panels[btn.id] = document.getElementById(btn.getAttribute('aria-controls'));
    });
    function select(btn) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var p = panels[b.id];
        if (p) p.hidden = !on;
      });
    }
    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn); });
      btn.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = buttons[(i + 1) % buttons.length];
        if (e.key === 'ArrowLeft') n = buttons[(i - 1 + buttons.length) % buttons.length];
        if (n) { e.preventDefault(); n.focus(); select(n); }
      });
    });
  });

  /* ---------- slideshow ---------- */
  document.querySelectorAll('[data-sg-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sg-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sg-slide-dot'));
    var count = root.querySelector('.sg-slide-count');
    if (!slides.length) return;
    var idx = 0;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
    }
    var prev = root.querySelector('[data-sg-prev]');
    var next = root.querySelector('[data-sg-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); });
    });
    /* touch swipe */
    var x0 = null;
    root.querySelector('.sg-slideshow-frame').addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
    }, { passive: true });
    root.querySelector('.sg-slideshow-frame').addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    show(0);
  });

  /* ---------- product form (variant pickers) ---------- */
  document.querySelectorAll('[data-sg-product]').forEach(function (root) {
    var data = root.querySelector('[data-sg-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-sg-option]'));
    if (!selects.length) return;
    selects.sort(function (a, b) {
      return parseInt(a.getAttribute('data-sg-option-index'), 10) - parseInt(b.getAttribute('data-sg-option-index'), 10);
    });
    var idInput = root.querySelector('[data-sg-variant-id]');
    var addBtn = root.querySelector('[data-sg-add]');
    var priceEl = root.querySelector('[data-sg-price]');
    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function update() {
      var opts = selects.map(function (s) { return s.value; });
      var found = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) { found = v; break; }
      }
      if (!found) return;
      if (idInput) idInput.value = found.id;
      if (priceEl) {
        priceEl.innerHTML = found.compare
          ? '<span class="sg-price-sale">' + esc(found.price) + '</span><span class="sg-price-compare">' + esc(found.compare) + '</span>'
          : esc(found.price);
      }
      if (addBtn) {
        addBtn.disabled = !found.available;
        addBtn.textContent = found.available ? 'Add to cart' : 'Sold out';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ---------- mailing list popup ---------- */
  (function () {
    var overlay = document.getElementById('sg-mailing-modal');
    if (!overlay) return;
    var form = document.getElementById('sg-mailing-modal-form');
    var formWrap = document.getElementById('sg-mailing-modal-body');
    var thanks = document.getElementById('sg-mailing-modal-thanks');
    var closeBtn = document.getElementById('sg-mailing-modal-close');
    var doneBtn = document.getElementById('sg-mailing-modal-done');
    var emailInput = document.getElementById('sg-mce-EMAIL');
    var KEY = 'sg-mailing-popup';
    var THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

    function remember(value) {
      try { localStorage.setItem(KEY, value); } catch (e) { /* storage unavailable */ }
    }

    function openModal() {
      overlay.hidden = false;
      document.body.classList.add('sg-modal-open');
      window.setTimeout(function () { emailInput.focus(); }, 60);
    }

    function closeModal(subscribed) {
      overlay.hidden = true;
      document.body.classList.remove('sg-modal-open');
      remember(String(Date.now()));
    }

    closeBtn.addEventListener('click', function () { closeModal(false); });
    doneBtn.addEventListener('click', function () { closeModal(true); });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) closeModal(false);
    });
    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      formWrap.hidden = true;
      thanks.hidden = false;
      remember(String(Date.now()));
    });

    /* footer "Mailing list" link re-opens the popup on demand */
    document.querySelectorAll('[data-sg-mailing-reopen]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        formWrap.hidden = false;
        thanks.hidden = true;
        openModal();
      });
    });

    var show = true;
    try {
      var seen = localStorage.getItem(KEY);
      show = !seen || (seen !== 'done' && Date.now() - Number(seen) > THIRTY_DAYS);
    } catch (e) { show = true; }
    if (show) window.setTimeout(openModal, 1500);
  })();
})();
